import Cards from 'components/activity/cards/main/containers/CardsContainer';
import PinOptions from 'components/activity/cards/pinOptions/containers/PinOptionsContainer';

export default [
    { path: '', component: Cards, pageTitle: 'Cards' },
    { path: 'pin-options', component: PinOptions, pageTitle: 'Pin Options' },
];
